import { configureStore } from '@reduxjs/toolkit';

import drawer from './drawer.slice';

export const store = configureStore({
  reducer: {
    // app-level
    drawer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
